import { SnippetExperience, VoiceSnippetCloseAction, AvatarSnippetCloseAction } from "../../utilities/types";

export type DropDownOption = string | { key: string; label: string };

interface IDropDownOptions {
    [key: string]: DropDownOption[];
}

const DropDownOptions: IDropDownOptions = {
    borderStyles: [
        'dotted',
        'dashed',
        'solid',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'none',
        'hidden',
    ],
    default: [
        'Options Not Yet Assigned',
    ],
    fonts: [
        'inherit',
        'Druid Regular',
        'Arial',
        'Times New Roman',
        'Helvetica',
        'Times',
        'Courier New',
        'Verdana',
        'Courier',
        'Arial Narrow',
        'Candara',
        'Geneva',
        'Calibri',
        'Optima',
        'Cambria',
        'Garamond',
        'Perpetua',
        'Monaco',
        'Didot',
        'Brush Script MT',
        'Lucida Bright',
        'Copperplate',
    ],
    suggestedActionLayout: [
        'flow',
        'carousel',
        'stacked',
    ],
    timestampFormat: [
        'relative',
        'absolute',
    ],
    wordBreak: [
        'normal',
        'break-all',
        'break-word',
        'keep-all',
    ],
    bubbleNubOffset: ['bottom', 'top'],
    position:
    ['left', 'right'],
    scrollToEndButtonBehavior: ["off", 'any', 'unread'],
    greetingMessageAnimation: ['wordReveal', 'wordRise'],
    voiceTheme: ['auto', 'light', 'dark'],
    voiceAnimation: ['fluid', 'pulse', 'flow', 'aurora', 'ripple', 'nebula'],
    voiceOutboundPrepareAnimation: ['scan', 'gather', 'charge'],
    voiceOutboundCallingAnimation: ['pulse', 'dial', 'beacon'],
    avatarSnippetToChatOnClose: Object.values(AvatarSnippetCloseAction),
    voiceSnippetToChatOnClose: Object.values(VoiceSnippetCloseAction),
    snippetExperience: [
        { key: SnippetExperience.Chat, label: 'Start in Chat (Default)' },
        { key: SnippetExperience.Voice, label: 'Start in Voice Mode' },
        { key: SnippetExperience.Avatar, label: 'Start in Avatar Mode' },
    ],
};

export default DropDownOptions;